function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "X Circle Filled Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M10,0.000222222222 C15.5233333,0.000222222222 20,4.47688889 20,10.0002222 C20,15.5224444 15.5233333,20.0002222 10,20.0002222 C4.47666667,20.0002222 0,15.5224444 0,10.0002222 C0,4.47688889 4.47666667,0.000222222222 10,0.000222222222 Z M7.04164744,6.25563991 C6.82470748,6.03866398 6.47294916,6.03863483 6.25597324,6.25557479 C6.03899732,6.47251474 6.03896816,6.82427306 6.25590812,7.04124898 L6.25590812,7.04124898 L9.21422222,9.99988889 L6.25624145,12.9589732 C6.0393015,13.1759492 6.03933065,13.5277075 6.25630657,13.7446474 C6.47328249,13.9615874 6.82504081,13.9615582 7.04198077,13.7445823 L7.04198077,13.7445823 L9.99922222,10.7858889 L12.9581303,13.7445823 C13.1750703,13.9615582 13.5268286,13.9615874 13.7438045,13.7446474 C13.9607805,13.5277075 13.9608096,13.1759492 13.7438697,12.9589732 L13.7438697,12.9589732 L10.7852222,9.99988889 L13.744203,7.04124898 C13.9611429,6.82427306 13.9611138,6.47251474 13.7441379,6.25557479 C13.527162,6.03863483 13.1754036,6.03866398 12.9584637,6.25563991 L12.9584637,6.25563991 L10.0002222,9.21388889 Z",
  id: "x-circle-filled-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "x-circle-filled-Icon/Global/Delete-Fill",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "x-circle-filled-Swatches/Midnight",
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "x-circle-filled-Mask",
  fill: "currentcolor",
  xlinkHref: "#x-circle-filled-path-1"
})));

var SvgXCircleFilled = function SvgXCircleFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXCircleFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/x-circle-filled.f8ac8170.svg";
export { ForwardRef as ReactComponent };